import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCode,
  faDatabase,
  faServer,
  faVial,
  faTools,
} from "@fortawesome/free-solid-svg-icons";
import {
  faReact,
  faJs,
  faCss3,
  faHtml5,
  faGitAlt,
  faMicrosoft,
} from "@fortawesome/free-brands-svg-icons";
import "./Skills.css";

const skillsData = [
  // 🧠 Backend & Frameworks
  { name: "ASP.NET Core MVC", level: 90, icon: faMicrosoft },
  { name: "C#", level: 90, icon: faCode },
  { name: "Dapper ORM", level: 80, icon: faServer },
  { name: "Entity Framework", level: 75, icon: faDatabase },

  // 💅 Frontend Technologies
  { name: "Razor (.cshtml)", level: 80, icon: faHtml5 },
  { name: "JavaScript", level: 85, icon: faJs },
  { name: "jQuery", level: 80, icon: faJs },
  { name: "ReactJS", level: 75, icon: faReact },
  { name: "Bootstrap", level: 80, icon: faCss3 },

  // 🗄️ Databases
  { name: "Oracle", level: 75, icon: faDatabase },
  { name: "SQL Server", level: 80, icon: faDatabase },

  // ⚙️ Tools & Testing
  { name: "Git", level: 85, icon: faGitAlt },
  { name: "Postman", level: 75, icon: faTools },
  { name: "Unit Testing", level: 70, icon: faVial },
];

const Skills = () => {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimated(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="skills" className="skills-section">
      <h2 className="section-title">
        <FontAwesomeIcon icon={faCode} className="skills-icon" /> Skills
      </h2>

      <div className="skills-grid">
        {skillsData.map((skill, index) => (
          <div key={index} className="skill-item">
            <span className="skill-name">
              <FontAwesomeIcon icon={skill.icon} className="skill-icon" />{" "}
              {skill.name}
            </span>

            <div className="progress_bar">
              <div
                className="progress1"
                style={{ width: animated ? `${skill.level}%` : "0%" }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
